const bucketUrl = 'https://storage.googleapis.com/fplsblog/';

// This must contain file paths in either of the formats 'dirname/filename' or 'filename'
// NOTE: File names must be separated by '-' or '_' only.
const filePaths = [
	'external-react/features/arrow-right.svg',
	'share/right-chevron-icon-blue.svg',
	'external-react/auth/eye-open.svg',
	'share/upload-icon-gray.svg',
	'share/close-icon.svg',
	'google-icon.svg',
	'mail.svg'
];

// Returns camelCase version of file name.
export const getFileKey = (str) => {
	return str.replace(/-(\w)/g, (_, letter) => letter.toUpperCase())
	.replace(/_(\w)/g, (_, letter) => letter.toUpperCase());
};

// This function returns and object of file urls with the file key being the camelCase version of the filename.
// Example: The path 'share/facebook-icon-small.svg' can be accessed with files.facebookIconSmall
export const files = filePaths.reduce((acc, filePath) => {
	const fileName = filePath.split('/').pop();
	const fileKey = fileName && getFileKey(fileName.split('.')[0]);
	if (fileName && fileKey) acc[fileKey] = `${bucketUrl}${filePath}`;
	return acc;
}, {});